
export class Song
{
    public Id = "";
    public Name = "";
    public Url = "";

    constructor(id: string, name: string, url: string)
    {
        this.Id = id;
        this.Name = name;
        this.Url = url;
    }
}
